module.exports = __webpack_public_path__ + "img/work.b640e70a.png";